import React from 'react';
import Panel from './Panel';
import * as styles from './SketchPanel.module.scss';

export interface SketchPanelProps {
  sketchImage: any;
  onClick?: () => void;
  className?: string;
}

const SketchPanel = ({ sketchImage, onClick, className }: SketchPanelProps): React.ReactElement => {
  return (
    <Panel className={className} onClick={onClick}>
      <img className={styles.sketchImage} src={sketchImage}></img>
    </Panel>
  );
};

export default SketchPanel;
